// AI 模型的顯示名（第七輪 B7-12：〔指派攝影機〕對話框寫原始 ID「yolox-nano.person_vehicle_animal@1」）：
// 字串表 ai.model.<id> 有就用；沒有就從 ID 的偵測對象組白話名（person / vehicle / animal →「人／車／動物偵測」），
// 「nano / tiny / lite」這類輕量版標「（輕量）」；都認不出來才寫「AI 模型」＋版本，不露原始 ID。
type T = (k: string, o?: Record<string, unknown>) => string;

const SUBJECTS = ['person', 'human', 'vehicle', 'car', 'animal', 'pet', 'face', 'plate', 'package', 'fire', 'smoke'] as const;

export function aiModelName(t: T, id: string): string {
  const hit = t(`ai.model.${id}`, { defaultValue: '' });
  if (hit) return hit;
  const [base, ver] = id.split('@');
  const parts = base.toLowerCase().split(/[._\-\s]+/);
  const subj = SUBJECTS.filter((s) => parts.includes(s)).map((s) => t(`ai.subject.${s === 'human' ? 'person' : s === 'car' ? 'vehicle' : s === 'pet' ? 'animal' : s}`));
  const uniq = [...new Set(subj)];
  const light = parts.some((p) => /^(nano|tiny|lite|mini|n|s)$/.test(p) || /nano|tiny|lite/.test(p));
  if (uniq.length) return t(light ? 'ai.model_detect_light' : 'ai.model_detect', { what: uniq.join(t('ai.subject_sep')) });
  return t('ai.model_generic', { v: ver ?? '' });
}
